<template>
    <v-card min-width="20vw" align="center" justify="center" outlined>
        <v-card-title >
            <v-list-item>
                <v-list-item-title><h2>{{ $t('deleteAsset') }}</h2></v-list-item-title>
                <v-spacer/>
                <v-list-item-action>
                    <v-icon class="icon" @click="cancelDelete" icon>fa-times</v-icon>
                </v-list-item-action>
            </v-list-item>
        </v-card-title>
        <v-card-text class="px-7 py-7">
            <p v-html="$t('areYouSureToDeleteAsset',{ticker:asset.ticker})"></p>
            <v-btn @click="deleteAsset">{{ $t('yesDeleteIt') }}</v-btn>
        </v-card-text>
    </v-card>
</template>

<script>
    import Repository from '../../repositories/asset';
    import { mapMutations } from 'vuex';

    export default {
        name: "DeleteAsset",
        props: {
            asset: Object,
        },
        methods: {
            ...mapMutations(["setAssets"]),
            async deleteAsset() {
                await Repository.deleteAssetToUserWatchlist(this.asset.id).then((response) => {
                    if(response.status < 400) {
                        if(response.data)
                            Repository.allAssetsOfUser().then((responseAll) => {
                                this.setAssets(responseAll.data);
                            });
                        else
                            alert(this.$t('alertMessage_DeleteAsset'))
                    }
                });
                this.$emit("closeDeleteWindow");
            },
            cancelDelete() {
                this.$emit("closeDeleteWindow");
            },
        },
    }
</script>

<style scoped>

</style>


